import lToast from './src/index'

export default {
  install (Vue) {
    Vue.prototype.$lToast = lToast
  }
}

export { lToast }

